import {
  API_ADMIN_ACCOUNTING,
  API_ADMIN_ACCOUNTING_ACCOUNT,
  API_ADMIN_ACCOUNTING_ACCOUNT_BY_ID,
  API_ADMIN_ACCOUNTING_ACCOUNT_CLEAR,
  API_ADMIN_ACCOUNTING_ACCOUNT_DOWNLOAD,
  API_ADMIN_ACCOUNTING_ACCOUNT_IMPORT,
  API_ADMIN_ACCOUNTING_ACCOUNT_IMPORT_QUICKBOOKS,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_BEGINNING_BALANCE,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_BY_ID,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_IMPORT,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILE,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILIATION_DETAIL,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILIATION_HISTORY,
  API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_SPLIT,
  API_ADMIN_ACCOUNTING_BY_FILE_ID,
  API_ADMIN_ACCOUNTING_BY_ID,
  API_ADMIN_ACCOUNTING_CATEGORY,
  API_ADMIN_ACCOUNTING_CATEGORY_BY_ID,
  API_ADMIN_ACCOUNTING_DASHBOARD,
  API_ADMIN_ACCOUNTING_ESCROW_CUSTODIAL,
  API_ADMIN_ACCOUNTING_ESCROW_CUSTODIAL_SETTINGS,
  API_ADMIN_ACCOUNTING_FILE,
  API_ADMIN_ACCOUNTING_FILE_BY_ID,
  API_ADMIN_ACCOUNTING_FINANCIAL_STATEMENTS,
  API_ADMIN_ACCOUNTING_GENERAL_LEDGER,
  API_ADMIN_ACCOUNTING_GENERAL_LEDGER_DOWNLOAD,
  API_ADMIN_ACCOUNTING_GENERAL_LEDGER_ENTRY,
  API_ADMIN_ACCOUNTING_GENERAL_LEDGER_IMPORT,
  API_ADMIN_ACCOUNTING_GENERAL_LEDGER_NEXT_REF,
  API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE,
  API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE_BY_ID,
  API_ADMIN_ACCOUNTING_HISTORY_BY_ID,
  API_ADMIN_ACCOUNTING_LOAN_REPURCHASES,
  API_ADMIN_ACCOUNTING_LOAN_REPURCHASES_BY_ID,
  API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES,
  API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES_BY_ID,
  API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER,
  API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER_BY_ID,
  API_ADMIN_ACCOUNTING_RECEIVABLE,
  API_ADMIN_ACCOUNTING_RECEIVABLE_BY_ID,
  API_ADMIN_ACCOUNTING_RECEIVABLE_PAID_EMAIL,
  API_ADMIN_ACCOUNTING_RECEIVABLE_PDF,
  API_ADMIN_ACCOUNTING_RECEIVABLE_REMIND,
  API_ADMIN_ACCOUNTING_RECEIVABLE_SETTINGS,
  API_ADMIN_ACCOUNTING_RECEIVABLE_XLSX,
  API_ADMIN_ACCOUNTING_RECONCILIATION_ENGINE,
  API_ADMIN_ACCOUNTING_RELATIONS_BY_ID,
  API_ADMIN_ACCOUNTING_REPURCHASE_RESERVE,
  API_ADMIN_ACCOUNTING_SERVICING_MSR,
  API_ADMIN_ACCOUNTING_SERVICING_MSR_LOANS,
  API_ADMIN_ACCOUNTING_SERVICING_MSR_LOANS_BY_ID,
  API_ADMIN_ACCOUNTING_SERVICING_MSR_SETTINGS,
  API_ADMIN_ACCOUNTING_TREASURY,
  API_ADMIN_ACCOUNTING_TREASURY_BANK_ACCOUNTS,
  API_ADMIN_ACCOUNTING_TREASURY_BANK_ACCOUNTS_BY_ID,
  API_ADMIN_ACCOUNTING_TREASURY_WIRE_BLOTTER,
  API_ADMIN_ACCOUNTING_TREASURY_WIRE_BLOTTER_BY_ID,
  API_ADMIN_ACCOUNTING_TRIAL_BALANCE,
  API_ADMIN_ACCOUNTING_VENDOR,
  API_ADMIN_ACCOUNTING_VENDOR_BY_ID,
  API_ADMIN_ACCOUNTING_VENDOR_CATEGORY,
  API_ADMIN_ACCOUNTING_VENDOR_CATEGORY_BY_ID,
  API_ADMIN_ACCOUNTING_VENDOR_DOWNLOAD,
  API_ADMIN_ACCOUNTING_VENDOR_PAYMENTS,
  API_ADMIN_ACCOUNTING_WAREHOUSE_LINES,
  API_ADMIN_ACCOUNTING_WAREHOUSE_LINES_BY_ID,
  API_ADMIN_ACCOUNTING_WAREHOUSE_LINES_OPTIONS,
} from 'config'
import Api from 'services/api'

import { downloadFile } from '../documents'

/**
 * Accounting Categories
 */
export const getBaseAccountingCategories = (type: string = '') => {
  return Api.get(API_ADMIN_ACCOUNTING_CATEGORY_BY_ID, { type }, { id: 'base' })
}

export const getAccountingCategories = (type: string = '') => {
  return Api.get(API_ADMIN_ACCOUNTING_CATEGORY, { type })
}

export const createAccountingCategory = (data: { baseId: number; parentId: number; value: string }) => {
  return Api.post(API_ADMIN_ACCOUNTING_CATEGORY, data)
}

export const updateAccountingCategory = (id: number, value: string) => {
  return Api.put(API_ADMIN_ACCOUNTING_CATEGORY_BY_ID, { value }, { id })
}

export const deleteAccountingCategory = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_CATEGORY_BY_ID, {}, { id })
}

/**
 * Accounting Record
 */
export const getAccounting = (filters: Record<string, any>) => {
  return Api.get(API_ADMIN_ACCOUNTING, filters)
}

export const getAccountingById = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_BY_ID, {}, { id })
}

export const getAccountingHistory = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_HISTORY_BY_ID, {}, { id })
}

export const getAccountingRelations = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_RELATIONS_BY_ID, {}, { id })
}

export const parseAccountingFile = (type: string, file: File): Promise<{ data: string[][]; file: any }> => {
  return Api.uploadFiles(API_ADMIN_ACCOUNTING_BY_ID, {}, { id: `file/${type}` }, [file])
}

export const analyzeAccounting = (data: Record<string, any>[]): Promise<number[]> => {
  return Api.post(API_ADMIN_ACCOUNTING_BY_ID, data, { id: 'analyze' }, { timeout: 600000 })
}

export const submitAccounting = (file: Record<string, any> | null, data: Record<string, any>[]) => {
  return Api.post(API_ADMIN_ACCOUNTING, { file, data })
}

export const updateAccounting = (data: Record<string, any>[]) => {
  return Api.put(API_ADMIN_ACCOUNTING, data)
}

export const updateAccountingById = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_BY_ID, data, { id })
}

export const deleteAccounting = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_BY_ID, {}, { id })
}

/**
 * Accounting Accounts
 */
export const getAccountingAccount = () => {
  return Api.get(API_ADMIN_ACCOUNTING_ACCOUNT)
}

export const createAccountingAccount = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_ACCOUNT, data)
}

export const updateAccountingAccount = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_ACCOUNT_BY_ID, data, { id })
}

export const deleteAccountingAccount = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_ACCOUNT_BY_ID, {}, { id })
}

export const clearAccountingAccounts = () => {
  return Api.post(API_ADMIN_ACCOUNTING_ACCOUNT_CLEAR, {})
}

export const downloadAccountingAccounts = async () => {
  const res: Blob = await Api.get(
    API_ADMIN_ACCOUNTING_ACCOUNT_DOWNLOAD,
    {},
    {},
    {
      responseType: 'blob',
    },
  )
  downloadFile(`Chart_of_Accounts.xlsx`, res)
}

export const importAccountingAccounts = (file: File) => {
  return Api.uploadFiles(API_ADMIN_ACCOUNTING_ACCOUNT_IMPORT, {}, {}, [file])
}

export const importAccountingAccountsFromQuickBooks = (file: File) => {
  return Api.uploadFiles(API_ADMIN_ACCOUNTING_ACCOUNT_IMPORT_QUICKBOOKS, {}, {}, [file])
}

/**
 * Accounting Account Transactions
 */
export const getAccountingAccountTransactions = (accountNo: number, filters: Record<string, any>) => {
  return Api.get(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS, filters, { accountNo })
}

export const createAccountingAccountTransaction = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS, data, { accountNo: data.accountNo })
}

export const updateAccountingAccountTransaction = (id: number, accountNo: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_BY_ID, data, { accountNo, id })
}

export const deleteAccountingAccountTransaction = (id: number, accountNo: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_BY_ID, {}, { accountNo, id })
}

export const splitAccountingAccountTransaction = (
  accountNo: number,
  id: number,
  data: { lines: Array<{ account: number; payment: number; deposit: number; memo?: string; class?: string }> },
) => {
  return Api.post(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_SPLIT, data, { accountNo, id })
}

export const reconcileAccountingAccountTransactions = (
  accountNo: number,
  data: {
    transactionIds: number[]
    statementDate: string
    endingBalance: number
    serviceCharge?: number
    interest?: number
  },
) => {
  return Api.post(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILE, data, { accountNo })
}

export const getAccountingReconciliationHistory = (accountNo: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILIATION_HISTORY, {}, { accountNo })
}

export const getAccountingReconciliationDetail = (accountNo: number, reconciliationId: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_RECONCILIATION_DETAIL, {}, { accountNo, reconciliationId })
}

export const getAccountingAccountBeginningBalance = (accountNo: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_BEGINNING_BALANCE, {}, { accountNo })
}

export const importAccountTransactions = (accountNo: number, file: File) => {
  return Api.uploadFiles(API_ADMIN_ACCOUNTING_ACCOUNT_TRANSACTIONS_IMPORT, {}, { accountNo }, [file])
}

/**
 * Accounting Files
 */
export const getAccountingFiles = (type: string) => {
  return Api.get(API_ADMIN_ACCOUNTING_FILE, { type })
}

export const getAccountingFilePropById = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_FILE_BY_ID, {}, { id })
}

export const deleteAccountingFile = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_FILE_BY_ID, {}, { id })
}

export const getAccountingByFileId = (fileId: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_BY_FILE_ID, {}, { fileId })
}

/**
 * Accounting Vendor Categories
 */
export const getAccountingVendorCategories = () => {
  return Api.get(API_ADMIN_ACCOUNTING_VENDOR_CATEGORY)
}

export const createAccountingVendorCategory = (data: { value: string }) => {
  return Api.post(API_ADMIN_ACCOUNTING_VENDOR_CATEGORY, data)
}

export const updateAccountingVendorCategory = (id: number, value: string) => {
  return Api.put(API_ADMIN_ACCOUNTING_VENDOR_CATEGORY_BY_ID, { value }, { id })
}

export const deleteAccountingVendorCategory = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_VENDOR_CATEGORY_BY_ID, {}, { id })
}

/**
 * Accounting Vendors
 */
export const getAccountingVendors = (filters: Record<string, any>) => {
  return Api.get(API_ADMIN_ACCOUNTING_VENDOR, filters)
}

export const createAccountingVendor = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_VENDOR, data)
}

export const updateAccountingVendor = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_VENDOR_BY_ID, data, { id })
}

export const deleteAccountingVendor = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_VENDOR_BY_ID, {}, { id })
}

/** Everything paid to this vendor, across every loan. */
export const getAccountingVendorPayments = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_VENDOR_PAYMENTS, {}, { id })
}

export const getAccountsReceivables = (filters: Record<string, any>) => {
  return Api.get(API_ADMIN_ACCOUNTING_RECEIVABLE, filters)
}

export const getAccountsReceivableSettings = () => {
  return Api.get(API_ADMIN_ACCOUNTING_RECEIVABLE_SETTINGS)
}

export const saveAccountsReceivableSettings = (data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_RECEIVABLE_SETTINGS, data)
}

export const createAccountsReceivable = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_RECEIVABLE, data)
}

export const updateAccountsReceivable = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_RECEIVABLE_BY_ID, data, { id })
}

export const deleteAccountsReceivable = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_RECEIVABLE_BY_ID, {}, { id })
}

export const remindAccountsReceivable = (id: number) => {
  return Api.post(API_ADMIN_ACCOUNTING_RECEIVABLE_REMIND, {}, { id })
}

export const sendAccountsReceivablePaidEmail = (id: number) => {
  return Api.post(API_ADMIN_ACCOUNTING_RECEIVABLE_PAID_EMAIL, {}, { id })
}

export const downloadAccountsReceivablePdf = async (id: number, invoiceNo: string) => {
  const res: Blob = await Api.get(API_ADMIN_ACCOUNTING_RECEIVABLE_PDF, {}, { id }, { responseType: 'blob' })
  downloadFile(`${invoiceNo || 'Invoice'}.pdf`, res)
}

export const downloadAccountsReceivableExcel = async (id: number, invoiceNo: string) => {
  const res: Blob = await Api.get(API_ADMIN_ACCOUNTING_RECEIVABLE_XLSX, {}, { id }, { responseType: 'blob' })
  downloadFile(`${invoiceNo || 'Invoice'}.xlsx`, res)
}

export const downloadAccountingVendors = async () => {
  const res: Blob = await Api.get(
    API_ADMIN_ACCOUNTING_VENDOR_DOWNLOAD,
    {},
    {},
    {
      responseType: 'blob',
    },
  )
  downloadFile(`Accounting Vendors.csv`, res)
}

/**
 * General Ledger
 */
export const getGeneralLedger = (filters: Record<string, any>) => {
  return Api.get(API_ADMIN_ACCOUNTING_GENERAL_LEDGER, filters)
}

export const getGeneralLedgerNextRefNo = () => {
  return Api.get(API_ADMIN_ACCOUNTING_GENERAL_LEDGER_NEXT_REF)
}

export const getGeneralLedgerEntry = (id: number) => {
  return Api.get(API_ADMIN_ACCOUNTING_GENERAL_LEDGER_ENTRY, {}, { id })
}

export const downloadGeneralLedger = async (filters: Record<string, any>) => {
  const res: Blob = await Api.get(API_ADMIN_ACCOUNTING_GENERAL_LEDGER_DOWNLOAD, filters, {}, { responseType: 'blob' })
  downloadFile(`General_Ledger.xlsx`, res)
}

export const getTrialBalance = () => {
  return Api.get(API_ADMIN_ACCOUNTING_TRIAL_BALANCE)
}

export const getFinancialStatements = () => {
  return Api.get(API_ADMIN_ACCOUNTING_FINANCIAL_STATEMENTS)
}

export const importGeneralLedgerTransactions = (file: File) => {
  return Api.uploadFiles(API_ADMIN_ACCOUNTING_GENERAL_LEDGER_IMPORT, {}, {}, [file])
}

/**
 * Warehouse Lines & Loan Subledger
 */
export const getWarehouseLines = () => Api.get(API_ADMIN_ACCOUNTING_WAREHOUSE_LINES)

export const getWarehouseLineOptions = () => Api.get(API_ADMIN_ACCOUNTING_WAREHOUSE_LINES_OPTIONS)

export const createWarehouseLine = (data: Record<string, any>) => Api.post(API_ADMIN_ACCOUNTING_WAREHOUSE_LINES, data)

export const updateWarehouseLine = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_WAREHOUSE_LINES_BY_ID, data, { id })

export const deleteWarehouseLine = (id: number) => Api.delete(API_ADMIN_ACCOUNTING_WAREHOUSE_LINES_BY_ID, {}, { id })

export const getLoanSubledger = () => Api.get(API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER)

export const createLoanSubledger = (data: Record<string, any>) => Api.post(API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER, data)

export const updateLoanSubledger = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER_BY_ID, data, { id })

export const deleteLoanSubledger = (id: number) => Api.delete(API_ADMIN_ACCOUNTING_LOAN_SUBLEDGER_BY_ID, {}, { id })

/**
 * Treasury & Wires
 */
export const getTreasury = () => Api.get(API_ADMIN_ACCOUNTING_TREASURY)

export const createBankAccount = (data: Record<string, any>) =>
  Api.post(API_ADMIN_ACCOUNTING_TREASURY_BANK_ACCOUNTS, data)

export const updateBankAccount = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_TREASURY_BANK_ACCOUNTS_BY_ID, data, { id })

export const deleteBankAccount = (id: number) =>
  Api.delete(API_ADMIN_ACCOUNTING_TREASURY_BANK_ACCOUNTS_BY_ID, {}, { id })

export const createWireBlotter = (data: Record<string, any>) =>
  Api.post(API_ADMIN_ACCOUNTING_TREASURY_WIRE_BLOTTER, data)

export const updateWireBlotter = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_TREASURY_WIRE_BLOTTER_BY_ID, data, { id })

export const deleteWireBlotter = (id: number) =>
  Api.delete(API_ADMIN_ACCOUNTING_TREASURY_WIRE_BLOTTER_BY_ID, {}, { id })

/**
 * Loan Sales & Trades
 */
export const getLoanSalesTrades = () => Api.get(API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES)

export const createLoanSaleTrade = (data: Record<string, any>) => Api.post(API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES, data)

export const updateLoanSaleTrade = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES_BY_ID, data, { id })

export const deleteLoanSaleTrade = (id: number) => Api.delete(API_ADMIN_ACCOUNTING_LOAN_SALES_TRADES_BY_ID, {}, { id })

export const createLoanRepurchase = (data: Record<string, any>) => Api.post(API_ADMIN_ACCOUNTING_LOAN_REPURCHASES, data)

export const updateLoanRepurchase = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_LOAN_REPURCHASES_BY_ID, data, { id })

export const deleteLoanRepurchase = (id: number) => Api.delete(API_ADMIN_ACCOUNTING_LOAN_REPURCHASES_BY_ID, {}, { id })

export const updateRepurchaseReserve = (data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_REPURCHASE_RESERVE, data)

/**
 * Accounting Dashboard
 */
export const getAccountingDashboard = () => Api.get(API_ADMIN_ACCOUNTING_DASHBOARD)

/**
 * Hedging & Fair Value
 */
export const getHedgingFairValue = () => Api.get(API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE)

export const createFairValueInstrument = (data: Record<string, any>) =>
  Api.post(API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE, data)

export const updateFairValueInstrument = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE_BY_ID, data, { id })

export const deleteFairValueInstrument = (id: number) =>
  Api.delete(API_ADMIN_ACCOUNTING_HEDGING_FAIR_VALUE_BY_ID, {}, { id })

/**
 * Escrow & Custodial
 */
export const getEscrowCustodial = () => Api.get(API_ADMIN_ACCOUNTING_ESCROW_CUSTODIAL)

export const updateCustodialSettings = (data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_ESCROW_CUSTODIAL_SETTINGS, data)

/**
 * Servicing & MSR
 */
export const getServicingMsr = () => Api.get(API_ADMIN_ACCOUNTING_SERVICING_MSR)

export const createMsrLoan = (data: Record<string, any>) => Api.post(API_ADMIN_ACCOUNTING_SERVICING_MSR_LOANS, data)

export const updateMsrLoan = (id: number, data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_SERVICING_MSR_LOANS_BY_ID, data, { id })

export const deleteMsrLoan = (id: number) => Api.delete(API_ADMIN_ACCOUNTING_SERVICING_MSR_LOANS_BY_ID, {}, { id })

export const updateServicingSettings = (data: Record<string, any>) =>
  Api.put(API_ADMIN_ACCOUNTING_SERVICING_MSR_SETTINGS, data)

/**
 * Reconciliation Engine
 */
export const getReconciliationEngine = () => Api.get(API_ADMIN_ACCOUNTING_RECONCILIATION_ENGINE)
